import styled from 'styled-components';

interface BaseProps {
	isMobile: boolean;
	sidebarVisible: boolean;
	sidebarDocked: boolean;
	sidebarWidth: number;
}

export const Base = styled.div<BaseProps>`
	position: relative;
	height: 100vh;
	background-color: ${({ theme }) => theme.gray[0]};

	${({ isMobile, sidebarDocked, sidebarWidth }) =>
		isMobile
			? `
		display: block;
	`
			: `
		display: grid;
		grid-template-columns: ${sidebarDocked ? `${sidebarWidth}px 1fr` : '0 1fr'};
		transition: none;
	`}
`;

export const VersionBanner = styled.div`
	position: fixed;
	bottom: 16px;
	right: 16px;
	z-index: 99999;
	display: flex;
	align-items: center;
	gap: 12px;
	background-color: ${({ theme }) => theme.blue[600]};
	color: white;
	padding: 12px 20px;
	border-radius: 8px;
	font-size: 13px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

	a {
		color: white;
		text-decoration: underline;
		&:hover {
			opacity: 0.8;
		}
	}

	button {
		background: none;
		border: none;
		color: white;
		opacity: 0.7;
		font-size: 16px;
		padding: 0;
		line-height: 1;
		&:hover {
			opacity: 1;
		}
	}
`;

interface MainContentProps {
	isMobile: boolean;
	sidebarVisible: boolean;
	sidebarWidth: number;
}

export const MainContent = styled.div<MainContentProps>`
	height: 100vh;
	overflow: hidden;
	position: relative;

	${({ isMobile, sidebarVisible, sidebarWidth }) =>
		isMobile
			? `
		width: 100%;
		transform: ${sidebarVisible ? `translateX(${sidebarWidth}px)` : 'none'};
		transition: transform 0.3s ease;
		backdrop-filter: ${sidebarVisible ? 'blur(2px)' : 'none'};
	`
			: `
		grid-column: 2;
	`}
`;
